import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import WhatsAppButton from "@/components/ui/WhatsAppButton";

const SolutionSection: React.FC = () => {
  return (
    <section id="equiparacao-hospitalar" className="py-8 md:py-16 px-4 md:px-6 bg-accent/30 scroll-mt-24 md:scroll-mt-28">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-6 md:mb-10">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            ECONOMIZE E RESTITUA IMPOSTOS
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
            Inteligência tributária aumenta seu lucro
          </h2>
        </div>

        <Card className="shadow-sm">
          <CardContent className="p-4 md:p-6 space-y-4 text-muted-foreground leading-relaxed">
            <p>
              O problema se agrava ainda mais quando esses impostos são calculados com base em estimativas de lucros que muitas vezes são superiores ao que você realmente obtém, resultando em <strong className="text-foreground">pagamentos excessivos e desnecessários</strong>.
            </p>
            <p>
              Esse cenário pode ser desesperador para profissionais e empresas da área de saúde que buscam prosperar e expandir seus negócios, mas veem seus recursos financeiros sendo consumidos por impostos que poderiam ser evitados ou minimizados.
            </p>
            <p>
              Se este é o seu caso, a <strong className="text-foreground">Tax Health tem uma solução muito importante para você</strong>.
            </p>
            <p>
              Nossa equipe de especialistas em tributação está pronta para ajudá-lo a identificar e implementar estratégias para reduzir sua carga tributária de forma legal e eficaz, permitindo que você economize dinheiro e invista em seu crescimento e sucesso.
            </p>
            <p>
              Com nosso apoio, você poderá <strong className="text-foreground">recuperar o controle financeiro</strong> de sua empresa e ter a tranquilidade de saber que está cumprindo suas obrigações fiscais de forma adequada, ao mesmo tempo em que maximiza seus lucros e investe em seu futuro.
            </p>

            <div className="pt-4">
              <WhatsAppButton 
                text="QUERO UM CONTATO"
                source="solution_section"
                size="lg"
                className="w-full md:w-auto min-h-[48px]"
                showIcon={false}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default SolutionSection;
